import { Modal } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrorCode } from 'state/global/error/action';
import * as selector from 'state/global/error/selector';
import { showErrorNotification } from 'util/error';

/**
 * useError()
 * @param {String} code E.g. 10001
 * @param {JSON} errorMessageJson { [errorCode]: "string" } or { [errorCode]: { message: "...", "description": "..." } }
 * @param {Node} ErrorMessageComponent <ErrorMessageComponent errorMessage={errorMessage} />
 */
export const useError = (
  code,
  errorMessageJson,
  ErrorMessageComponent = null
) => {
  const dispatch = useDispatch();
  const { errorCodeInfo } = useSelector((state) => ({
    errorCodeInfo: selector.selectErrorCodeInfo(state)
  }));

  const errorCodeEffect = errorCodeInfo[code];

  useEffect(() => {
    if (!errorCodeEffect) {
      return;
    }

    render(errorCodeEffect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCodeEffect]);

  const render = () => {
    const errorMessage = errorMessageJson[code] || code;

    if (!ErrorMessageComponent) {
      showErrorNotification(errorMessage);
    } else {
      Modal.error({
        content: <ErrorMessageComponent errorMessage={errorMessage} />,
        centered: true,
        closable: true,
        icon: null,
        className: 'modal-without-footer'
      });
    }
  };

  useEffect(
    () => () => {
      dispatch(clearErrorCode({ errorCode: code }));
    },
    [dispatch, code]
  );
};
